import React from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';

const Downloads = () => {
  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <h2 className="mb-4">📱 Install Taxi-Local on Your Device</h2>
          <Alert variant="info" className="mb-4">
            <strong>Quick Access:</strong> Add Taxi-Local to your home screen for instant access to jobs and notifications.
          </Alert>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col lg={6} className="mb-4">
          <Card className="h-100">
            <Card.Header className="bg-success text-white">
              <h4 className="mb-0">🤖 Android Installation</h4>
            </Card.Header>
            <Card.Body>
              <div className="mb-3">
                <h5>Step 1: Open in Chrome Browser</h5>
                <p>Make sure you're using Chrome browser on your Android device.</p>
              </div>
              
              <div className="mb-3">
                <h5>Step 2: Access Menu</h5>
                <p>Tap the three dots (⋮) in the top-right corner of Chrome.</p>
              </div>
              
              <div className="mb-3">
                <h5>Step 3: Add to Home Screen</h5>
                <p>Select "Add to Home screen" or "Install app" from the menu.</p>
              </div>
              
              <div className="mb-3">
                <h5>Step 4: Confirm Installation</h5>
                <p>Tap "Add" or "Install" when prompted. The app will appear on your home screen.</p>
              </div>
              
              <Alert variant="success" className="mt-3">
                <strong>✅ Done!</strong> You can now access Taxi-Local directly from your home screen.
              </Alert>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6} className="mb-4">
          <Card className="h-100">
            <Card.Header className="bg-primary text-white">
              <h4 className="mb-0">🍎 iPhone Installation</h4>
            </Card.Header>
            <Card.Body>
              <div className="mb-3">
                <h5>Step 1: Open in Safari Browser</h5>
                <p>Make sure you're using Safari browser on your iPhone.</p>
              </div>
              
              <div className="mb-3">
                <h5>Step 2: Access Share Menu</h5>
                <p>Tap the Share button (📤) at the bottom of Safari.</p>
              </div>
              
              <div className="mb-3">
                <h5>Step 3: Add to Home Screen</h5>
                <p>Scroll down and tap "Add to Home Screen" from the share options.</p>
              </div>
              
              <div className="mb-3">
                <h5>Step 4: Customize and Add</h5>
                <p>You can edit the name if desired, then tap "Add" in the top-right corner.</p>
              </div>
              
              <Alert variant="success" className="mt-3">
                <strong>✅ Done!</strong> Taxi-Local is now installed on your iPhone home screen.
              </Alert>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card className="border-warning">
            <Card.Header className="bg-warning text-dark">
              <h4 className="mb-0">💡 Benefits of Installing</h4>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <ul className="list-unstyled">
                    <li className="mb-2">🚀 <strong>Faster Access:</strong> No need to open browser and navigate</li>
                    <li className="mb-2">🔔 <strong>Push Notifications:</strong> Get instant job alerts</li>
                    <li className="mb-2">📱 <strong>App-like Experience:</strong> Full-screen interface</li>
                  </ul>
                </Col>
                <Col md={6}>
                  <ul className="list-unstyled">
                    <li className="mb-2">⚡ <strong>Offline Access:</strong> Some features work without internet</li>
                    <li className="mb-2">🎯 <strong>Direct Launch:</strong> Opens directly to your dashboard</li>
                    <li className="mb-2">🔒 <strong>Secure:</strong> Same security as the web version</li>
                  </ul>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <Card className="border-info">
            <Card.Header className="bg-info text-white">
              <h4 className="mb-0">📄 PDF Resources</h4>
            </Card.Header>
            <Card.Body>
              <p className="mb-3">Download helpful PDF documents for your taxi business:</p>
              <div className="list-group">
                <a 
                  href="/Daily Bookings.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                >
                  <div>
                    <h6 className="mb-1">📊 Daily Bookings</h6>
                    <small className="text-muted">Track and manage your daily booking records</small>
                  </div>
                  <span className="badge bg-primary rounded-pill">PDF</span>
                </a>
              </div>
              <Alert variant="info" className="mt-3 mb-0">
                <small>
                  <strong>💡 Tip:</strong> Right-click and "Save link as..." to download PDFs to your device for offline access.
                </small>
              </Alert>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <Alert variant="light" className="border">
            <h5>🆘 Need Help?</h5>
            <p className="mb-2">If you're having trouble installing the app:</p>
            <ul className="mb-0">
              <li>Make sure you're using the correct browser (Chrome for Android, Safari for iPhone)</li>
              <li>Ensure you have a stable internet connection</li>
              <li>Try refreshing the page and attempting the installation again</li>
              <li>Contact support if you continue to experience issues</li>
            </ul>
          </Alert>
        </Col>
      </Row>
    </Container>
  );
};

export default Downloads;
